// removed by extract-text-webpack-plugin
module.exports = {"black":"#000000","medium-grey":"#9f9f9f","viewsPerPageWrapper":"tnOgOWhkVpd1TFUZlcuTY"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/elements/Pagination/ViewsPerPageFilter/ViewsPerPageFilter.css
// module id = 995
// module chunks = 0